import { render } from "./FooterArea.vue?vue&type=template&id=af964b4a"
import script from "./FooterArea.vue?vue&type=script&lang=js"
export * from "./FooterArea.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\이운혁\\Desktop\\util\\gitleb\\incheon\\incheon_tpps_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__